import { graphql } from '@teachino/shared-infrastructure';

export const topicSyncDetailsQuery = graphql(`
  query TopicSyncDetails($topicId: String!) {
    topic(topicIdInput: { id: $topicId }) {
      __typename
      id
      name
      originDetails {
        id
        newAdditions
        contentChanged
      }
      permissions {
        canEditTopic
      }
    }
  }
`);
